// import React from 'react'
// import Form from 'react-bootstrap/Form';
// const DatePicker = ({ disabledInput, inputFieldLabel, requiredStar, onChange, value, name, placeholder, maxDate, dobSelection,  disabled=false, limitSelection }) => {
//   const currentDate = new Date().toISOString().split('T')[0];
//   const pastDate = new Date();
//   pastDate.setFullYear(pastDate.getFullYear() - 18);
//   const minDate = pastDate.toISOString().split('T')[0];

//   function onChangeHandler(e) {
//     onChange(e.target.value)
//   }

//   return (
//     <>
//     {!dobSelection &&
//     <>
//       <Form.Label>{inputFieldLabel} <span className='redStar'>{requiredStar}</span></Form.Label>

//       <Form.Control
//        disabled={disabled}
//         type="date"
//         onChange={onChangeHandler}
//         value={value}
//         name={name}
//         placeholder={placeholder}
//         max={currentDate}
//         className={`${disabledInput == false ? 'disabledInput' : ''}`}
//         onKeyDown={(e) => e.preventDefault()}
//         onPaste={(e) => e.preventDefault()} 

//       />
//       </>
//     }

//       {dobSelection &&
//        <>
//        <Form.Label>{inputFieldLabel}<span className='redStar'>{requiredStar}</span></Form.Label>
//         <Form.Control
//          disabled={disabled}
//           type="date"
//           onChange={onChangeHandler}
//           value={value}
//           name={name}
//           placeholder={placeholder}
//           max={minDate}
//           className={`${disabledInput == false ? 'disabledInput' : ''}`}
//           onKeyDown={(e) => e.preventDefault()}
//           onPaste={(e) => e.preventDefault()} 
        

//         />
//         </>

//       }

//       {/* exception checker true */}
//       {limitSelection &&
//       <>
//       <Form.Label>{inputFieldLabel}<span className='redStar'>{requiredStar}</span></Form.Label>
//       <Form.Control
//        disabled={disabled}
//         type="date"
//         onChange={onChangeHandler}
//         value={value}
//         name={name}
//         placeholder={placeholder}
//         max={currentDate}
//         className={`${disabledInput == false ? 'disabledInput' : ''}`}
//         onKeyDown={(e) => e.preventDefault()}
//         onPaste={(e) => e.preventDefault()} 
//       />
//       </>
//       }
//     </>
//   )
// }

// export default DatePicker

import React from "react";
import { DatePicker, Form } from "antd";
import dayjs from "dayjs";

const AntdDatePicker = ({
  disabledInput,
  inputFieldLabel,
  requiredStar,
  onChange,
  value,
  name,
  placeholder,
  dobSelection,
  disabled = false,
  limitSelection,
}) => {
  const currentDate = dayjs();
  const minDate = currentDate.subtract(18, "year"); 

  const disabledDate = (current) => {
    if (!current) return false;

    if (dobSelection) {
      return current > minDate.endOf("day"); 
    }

    return current > currentDate.endOf("day");
  };

  const handleChange = (date, dateString) => {
    onChange(dateString);
  };

  return (
    <div>
      <label style={{ display: "block", marginBottom: "6px", fontWeight: 600, color: "#7c7d82ff" }}>
        {inputFieldLabel} <span className="redStar">{requiredStar}</span>
      </label>

      <DatePicker
        value={value ? dayjs(value) : null}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={disabled}
        disabledDate={disabledDate}
        inputReadOnly
        style={{ width: "100%" }}
        className={`${disabledInput === false ? "disabledInput" : ""}`}
        defaultPickerValue={value ? dayjs(value) : dobSelection ? minDate : currentDate}
      />
    </div>
  );
  
};

export default AntdDatePicker;

